import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import constants from 'constants';

const {
  EXPORT_USERS_CSV
} = constants;

function Tools({
  count,
  deleteUsers
}) {
  return (
    <div className="admin_list">
      <h5>Users (<span>{count}</span>)</h5>
      <Link className="button_classic" to="/users/new">
        <i class="material-icons"></i>
        Add user
      </Link>
      <a className="button_classic" href={EXPORT_USERS_CSV} target="_blank">
        Export user details
      </a>
      <a className="button_delete" onClick={deleteUsers} href="#">Delete</a>
    </div>
  );
}

Tools.defaultProps = {};

Tools.propTypes = {};

export default Tools;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/User/Toolbar/Tools.jsx
 **/